import { configureStore } from "@reduxjs/toolkit";
import pollsReducer from "./polls/PollsSlice";
import appReducer from "./app/AppSlice";

export const store = configureStore({
    reducer: {
        polls: pollsReducer,
        app: appReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
